import { render } from "./http.vue?vue&type=template&id=15c8c7b6"
import script from "./http.vue?vue&type=script&lang=js"
export * from "./http.vue?vue&type=script&lang=js"

import "./http.vue?vue&type=style&index=0&id=15c8c7b6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__